import { render } from "./userSales.vue?vue&type=template&id=0dc4d172&scoped=true"
import script from "./userSales.vue?vue&type=script&lang=js"
export * from "./userSales.vue?vue&type=script&lang=js"

import "./userSales.vue?vue&type=style&index=0&id=0dc4d172&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc4d172"]])

export default __exports__